<section data-test="projectConsole" *ngIf="console">
  <pre>{{ console }}</pre>
</section>
